import { formatISODateTime, formatReadableDateShort, formatReadableTime } from 'shared/util/datetime-fns';
import type { Offer } from '@/interfaces';

export const FlightDateAndTime = ({ departureDate, returnDate }: Pick<Offer, 'departureDate' | 'returnDate'>) => {
    const departure = new Date(departureDate);
    const ret = new Date(returnDate);

    return (
        <p className="flex flex-row items-center gap-4 text-detail">
            <w-icon name="PlaneTakeOff" size="small" locale="nb" aria-hidden></w-icon>
            <time className="flex flex-row gap-4 capitalize" dateTime={formatISODateTime(departure)}>
                <span className="font-bold">{formatReadableDateShort(departure)}</span>
                <span>kl. {formatReadableTime(departure)}</span>
            </time>
            <span>-</span>
            <w-icon name="PlaneLand" size="small" locale="nb" aria-hidden></w-icon>
            <time className="flex flex-row gap-4 capitalize" dateTime={formatISODateTime(ret)}>
                <span className="font-bold">{formatReadableDateShort(ret)}</span>
                <span>kl. {formatReadableTime(ret)}</span>
            </time>
        </p>
    );
};
